var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
export var ButtonState;
(function (ButtonState) {
    ButtonState[ButtonState["Idle"] = 0] = "Idle";
    ButtonState[ButtonState["Hover"] = 1] = "Hover";
    ButtonState[ButtonState["Pressed"] = 2] = "Pressed";
})(ButtonState || (ButtonState = {}));
var StatesButtonBase = (function (_super) {
    __extends(StatesButtonBase, _super);
    function StatesButtonBase(scene, position, config) {
        var _this = this;
        var _a, _b;
        _this = _super.call(this, scene, position.x, position.y) || this;
        _this.name = (_a = config.name) !== null && _a !== void 0 ? _a : '';
        _this.config = config;
        _this.buttonState = ButtonState.Idle;
        _this.initializeBackground();
        if (_this.config.topImage) {
            _this.setTopImage(_this.config.topImage);
        }
        if (_this.config.bitmapTextConfig) {
            _this.setText(_this.config.bitmapTextConfig);
        }
        _this.updateSize();
        _this.setScale((_b = _this.config.scale) !== null && _b !== void 0 ? _b : 1);
        _this.changeState(ButtonState.Idle);
        _this.setInteractive({ cursor: 'pointer' });
        _this.scene.add.existing(_this);
        _this.bindEventHandlers();
        return _this;
    }
    StatesButtonBase.prototype.setTopImage = function (config) {
        if (this.topImage) {
            this.topImage.setActive(false).setVisible(false);
            this.remove(this.topImage, true);
        }
        this.topImage = this.scene.make.image(config, true);
        this.add(this.topImage);
        return;
    };
    StatesButtonBase.prototype.getTopImage = function () {
        return this.topImage;
    };
    StatesButtonBase.prototype.setText = function (config) {
        if (this.text) {
            this.text.setActive(false).setVisible(false);
            this.remove(this.text, true);
        }
        this.text = this.scene.make.bitmapText(config, true);
        this.add(this.text);
        this.config.bitmapTextConfig = config;
    };
    StatesButtonBase.prototype.getText = function () {
        return this.text;
    };
    StatesButtonBase.prototype.changeText = function (text) {
        var _a;
        (_a = this.text) === null || _a === void 0 ? void 0 : _a.setText(text);
    };
    StatesButtonBase.prototype.lockFromInput = function (lock) {
        if (lock === void 0) { lock = true; }
        if (lock) {
            this.disableInteractive();
            return;
        }
        this.setInteractive({ cursor: 'pointer' });
    };
    StatesButtonBase.prototype.updateSize = function () {
        var _a;
        var bounds = this.getBounds();
        this.setSize(bounds.width, bounds.height);
        if (!((_a = this.input) === null || _a === void 0 ? void 0 : _a.hitArea)) {
            this.setInteractive({
                hitArea: new Phaser.Geom.Rectangle(0, 0, bounds.width, bounds.height),
                hitAreaCallback: Phaser.Geom.Rectangle.Contains,
                cursor: 'pointer',
            });
        }
        this.input.hitArea.setTo(0, 0, bounds.width, bounds.height);
    };
    StatesButtonBase.prototype.bindEventHandlers = function () {
        var _this = this;
        this.on(Phaser.Input.Events.POINTER_UP, function () {
            _this.changeState(ButtonState.Idle);
        });
        this.on(Phaser.Input.Events.POINTER_DOWN, function () {
            _this.changeState(ButtonState.Pressed);
        });
        this.on(Phaser.Input.Events.POINTER_OVER, function () {
            if (_this.buttonState === ButtonState.Pressed) {
                return;
            }
            _this.changeState(ButtonState.Hover);
        });
        this.on(Phaser.Input.Events.POINTER_OUT, function () {
            _this.changeState(ButtonState.Idle);
        });
    };
    StatesButtonBase.prototype.changeState = function (state) {
        this.changeBackgroundTexture(state);
        this.buttonState = state;
        this.applyTextOffset(state);
        this.applyTopImageOffset(state);
    };
    StatesButtonBase.prototype.applyTopImageOffset = function (state) {
        var _a, _b, _c, _d;
        if (this.topImage) {
            var offset = (_b = (_a = this.config.offsets) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b[state];
            this.topImage.x = (_c = offset === null || offset === void 0 ? void 0 : offset.x) !== null && _c !== void 0 ? _c : 0;
            this.topImage.y = (_d = offset === null || offset === void 0 ? void 0 : offset.y) !== null && _d !== void 0 ? _d : 0;
        }
    };
    StatesButtonBase.prototype.applyTextOffset = function (state) {
        var _a, _b, _c, _d;
        if (this.text) {
            var offset = (_b = (_a = this.config.offsets) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b[state];
            this.text.x = (_c = offset === null || offset === void 0 ? void 0 : offset.x) !== null && _c !== void 0 ? _c : 0;
            this.text.y = (_d = offset === null || offset === void 0 ? void 0 : offset.y) !== null && _d !== void 0 ? _d : 0;
        }
    };
    return StatesButtonBase;
}(Phaser.GameObjects.Container));
export { StatesButtonBase };
